import { StatusBadge } from "@medusajs/ui"
import { DELIVERY_LABEL } from "../lib/format"
import { t, tc } from "../lib/i18n"
import type { DeliveryMethod, OrderListItem } from "../lib/medusa"

export function DeliveryBadge({ delivery }: { delivery: DeliveryMethod }) {
  return <StatusBadge color={delivery === "box_now" ? "blue" : delivery === "unknown" ? "grey" : "purple"}>{DELIVERY_LABEL[delivery]}</StatusBadge>
}

export function PaymentBadge({ payment }: { payment: OrderListItem["payment"] }) {
  if (payment.kind === "card") {
    return <StatusBadge color="green">{t("Card · paid")}</StatusBadge>
  }
  if (payment.kind === "cash") {
    return <StatusBadge color={payment.collected ? "green" : "orange"}>{payment.collected ? t("Cash · collected") : t("Cash · to collect")}</StatusBadge>
  }
  return <StatusBadge color="grey">{t("Payment unknown")}</StatusBadge>
}

export function FulfilmentBadge({ order }: { order: Pick<OrderListItem, "status" | "shipped" | "delivered" | "delivery"> }) {
  if (order.status === "canceled") return <StatusBadge color="red">{tc("order", "Cancelled")}</StatusBadge>
  if (order.delivered) return <StatusBadge color="green">{tc("order", "Delivered")}</StatusBadge>
  if (order.shipped) return <StatusBadge color="green">{tc("order", "Shipped")}</StatusBadge>
  return <StatusBadge color="orange">{order.delivery === "box_now" ? tc("order", "Not shipped") : tc("order", "Not handed over")}</StatusBadge>
}
